import {
  OBTENIR_OBSERVADORS,
  OBTENIR_OBSERVADORS_LLISTAT,
  OBTENIR_OBSERVADOR_ID,
  OBTENIR_DADES_OBSERVADOR,
  ESBORRAR_OBSERVADOR_SELECCIONAT,
  OBSERVADOR_INICIALITZAR,
  OBSERVADOR_INTRODUCCIO_MODIFICAR_CAMP,
  OBSERVADOR_INTRODUCCIO_DESCARTAR_CANVIS,
  OBSERVADOR_INTRODUCCIO_ENVIAR_FORMULARI_EN_CURS,
  OBSERVADOR_INTRODUCCIO_OMPLIR_DADES,
  OBSERVADOR_INTRODUCCIO_ENVIAR_FORMULARI_FINALITZADA,
  OBSERVADOR_INTRODUCCIO_MOSTRAR_ERRORS,
  OBTENIR_OBSERVADORS_ESPECIES
} from "./actionTypes";
import {
  fetchObtenirObservadors,
  fetchObtenirObservadorsLlistat,
  fetchObtenirDadesObservador,
  fetchObservadorIntroduccioCrearObservador,
  fetchObservadorIntroduccioEditarObservador,
  fetchObtenirObservadorsEspecies
} from "./consultesServidor";
import { getDataIntroduccioAsMoment } from "../reducers";
import {
  formulariNoShanModificatDades,
  obtenirErrorsDadesObservador,
  hiHaErrorsDadesFormulari
} from "../utils/formularis";
import {
  crearNotificacioDadesNoCanviades,
  crearNotificacioFormulariFaltenDadesObligatories,
  crearNotificacioSuccess,
  crearNotificacioError
} from "../utils/notificacio";
import { errorConsultaServidor } from "./error";
import { rutaObservadors } from "../routes";

export const obtenirDadesObservador = idObservador => {
  return {
    type: OBTENIR_DADES_OBSERVADOR,
    promise: fetchObtenirDadesObservador(idObservador)
  };
};

export const obtenirObservadors = dia => {
  return {
    type: OBTENIR_OBSERVADORS,
    promise: fetchObtenirObservadors(dia)
  };
};

export const obtenirObservadorsActiusEnDataIntroduccio = () => {
  return (dispatch, getState) => {
    const state = getState();
    const dia = getDataIntroduccioAsMoment(state);
    return dispatch({
      type: OBTENIR_OBSERVADORS,
      promise: fetchObtenirObservadors(dia)
    });
  };
};

export const obtenirObservadorsLlistat = () => {
  return {
    type: OBTENIR_OBSERVADORS_LLISTAT,
    promise: fetchObtenirObservadorsLlistat()
  };
};

export const obtenirObservadorsEspecies = () => {
  return {
    type: OBTENIR_OBSERVADORS_ESPECIES,
    promise: fetchObtenirObservadorsEspecies()
  };
};

export const getDadesObservadorSeleccionat = idObservador => {
  return {
    type: OBTENIR_OBSERVADOR_ID,
    payload: idObservador
  };
};

export const esborrarObservadorSeleccionat = () => {
  return {
    type: ESBORRAR_OBSERVADOR_SELECCIONAT,
    payload: null
  };
};

export const omplirDadesObservador = dadesOriginals => {
  return {
    type: OBSERVADOR_INTRODUCCIO_OMPLIR_DADES,
    payload: dadesOriginals
  };
};

export const observadorIntroduccioModificarCamp = (idCamp, valor) => {
  return {
    type: OBSERVADOR_INTRODUCCIO_MODIFICAR_CAMP,
    idCamp,
    valor
  };
};

export const observadorInicialitzar = () => {
  return {
    type: OBSERVADOR_INICIALITZAR
  };
};

export const observadorIntroduccioDescartarCanvis = () => {
  return {
    type: OBSERVADOR_INTRODUCCIO_DESCARTAR_CANVIS
  };
};

const observadorIntroduccioEnviarFormulariEnCurs = () => ({
  type: OBSERVADOR_INTRODUCCIO_ENVIAR_FORMULARI_EN_CURS
});

const observadorIntroduccioEnviarFormulariFinalitzada = () => ({
  type: OBSERVADOR_INTRODUCCIO_ENVIAR_FORMULARI_FINALITZADA
});

const observadorIntroduccioMostrarErrors = () => ({
  type: OBSERVADOR_INTRODUCCIO_MOSTRAR_ERRORS
});

export const observadorIntroduccioEnviarFormulari = routerHistory => {
  return (dispatch, getState) => {
    const estat = getState();
    const idObservador = estat.observadors.dades.idObservadorSeleccionat;
    const esNouObservador = idObservador ? false : true;
    const dadesOriginals = estat.observadors.formulari.originals;
    const dadesEditades = estat.observadors.formulari.editades;
    const errors = obtenirErrorsDadesObservador(dadesEditades, esNouObservador);
    const hiHaError = hiHaErrorsDadesFormulari(errors);
    if (hiHaError.length > 0) {
      dispatch(observadorIntroduccioMostrarErrors());
      crearNotificacioFormulariFaltenDadesObligatories();
      return;
    }

    let promesa;
    const rutaRedireccionamentSiInsercioOk = rutaObservadors;
    let missatgeNotificacioExit;
    let missatgeNotificacioError;

    let formData = new FormData();
    const nomObservador = dadesEditades.nom
      ? `${dadesEditades.nom} ${dadesEditades.cognom1}`
      : "";

    if (idObservador) {
      if (formulariNoShanModificatDades(dadesOriginals, dadesEditades)) {
        crearNotificacioDadesNoCanviades();
        return;
      }
      dispatch(observadorIntroduccioEnviarFormulariEnCurs());
      // editant observador
      let dadesAEnviar = Object.assign({}, dadesEditades);
      delete dadesAEnviar.indrets;
      delete dadesAEnviar.historic;
      delete dadesAEnviar.municipi;
      delete dadesAEnviar.comarca;
      delete dadesAEnviar.key;
      delete dadesAEnviar.historic;
      delete dadesAEnviar.foto;
      delete dadesAEnviar.indretsIndividusFenofases;
      if (dadesEditades.foto && dadesEditades.foto.fitxer) {
        formData.append("foto", dadesEditades.foto.fitxer);
      }
      formData.append("dades", JSON.stringify(dadesAEnviar));

      promesa = fetchObservadorIntroduccioEditarObservador(
        idObservador,
        formData
      );
      missatgeNotificacioExit = `Observador "${nomObservador}" editat correctament`;
      missatgeNotificacioError = "Error editant l'observador";
    } else {
      // creant observador: Observador -> Usuari -> historic_observador -> foto
      if (formulariNoShanModificatDades(dadesOriginals, dadesEditades)) {
        crearNotificacioDadesNoCanviades();
        return;
      }

      let dadesAEnviar = Object.assign({}, dadesEditades);
      delete dadesAEnviar.foto;
      if (dadesEditades.foto && dadesEditades.foto.fitxer) {
        formData.append("foto", dadesEditades.foto.fitxer);
      }
      formData.append("dades", JSON.stringify(dadesAEnviar));
      dispatch(observadorIntroduccioEnviarFormulariEnCurs());
      promesa = fetchObservadorIntroduccioCrearObservador(formData);

      missatgeNotificacioExit = `Observador "${nomObservador}" creat correctament`;
      missatgeNotificacioError = "Error creant l'observador";
    }

    return promesa.then(
      result => {
        dispatch(observadorIntroduccioEnviarFormulariFinalitzada());
        if (result && (result.msg || result.message)) {
          return crearNotificacioError(result.msg || result.message);
        }
        crearNotificacioSuccess(missatgeNotificacioExit);
        routerHistory.push(rutaRedireccionamentSiInsercioOk);
      },
      errorServidor => {
        dispatch(observadorIntroduccioEnviarFormulariFinalitzada());
        dispatch(
          errorConsultaServidor(errorServidor, missatgeNotificacioError)
        );
      }
    );
  };
};
